import { Grid } from '@mui/material';
import { Plus } from 'lucide-react';
import { MouseEvent, ReactNode } from 'react';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../../modules/translation/TranslationContext';
import { FilterPreferenceRecognizedLists } from '../../../services/modules/userContextPreferences/userContextPreferences.types';
import useTeceoStyles from '../../../useTeceoStyles';
import { FilterOptionV3, FilterProps } from '../../Crud/filters/sharedBetweenFilters/types';
import Chip from '../../v2/ui/Chip/Chip';
import Icon from '../../v2/ui/Icon/Icon';
import useFilterV3Styles from '../filter.styles';
import SelectedFilterList from './Filter/SelectedFilter/SelectedFilterList';

interface MobileFilterBarProps {
  fixedFilters?: ReactNode[];
  hasSelectedFilter: boolean;
  hasFilterOptions: boolean;
  list: FilterPreferenceRecognizedLists;
  formattedFilters: (FilterOptionV3 & { hasValue: boolean })[];
  onClickSelectedFilter: (event: MouseEvent<HTMLElement>, filter: FilterProps) => void;
  onClickAddFilter: (event: MouseEvent<HTMLElement>) => void;
}

function MobileFilterBar({
  fixedFilters,
  hasSelectedFilter,
  hasFilterOptions,
  list,
  formattedFilters,
  onClickSelectedFilter,
  onClickAddFilter,
}: MobileFilterBarProps) {
  const { classes } = useFilterV3Styles();
  const { classes: teceoClasses } = useTeceoStyles();
  const { translate } = useTranslation();

  return (
    <Grid container spacing={3 / 2}>
      <Grid size="grow">
        <Grid container spacing={1} sx={{ alignItems: 'flex-end' }} size="grow">
          {fixedFilters?.map((fixedFilter, index) => (
            <Grid key={`fixed-filter-${index}`} size={{ xs: 12, sm: 'auto' }}>
              {fixedFilter}
            </Grid>
          ))}
        </Grid>
      </Grid>
      {(hasSelectedFilter || hasFilterOptions) && (
        <Grid size={12}>
          <Grid container spacing={1} wrap="nowrap" className={teceoClasses.hideScrollbar}>
            {hasFilterOptions && (
              <Grid>
                <Chip
                  label={translate(LangEnum.GLOBAL_FILTER)}
                  onClick={onClickAddFilter}
                  size="small"
                  component="button"
                  className={classes.mobileFilterButton}
                  icon={<Icon icon={Plus} size="md" />}
                />
              </Grid>
            )}
            {hasSelectedFilter && (
              <Grid size={12}>
                <SelectedFilterList
                  list={list}
                  filters={formattedFilters}
                  onClick={onClickSelectedFilter}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default MobileFilterBar;
